import React, {Fragment} from 'react';
import { withRouter, Link, Redirect} from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";

import { Formik, Form, Field, ErrorMessage } from 'formik';

import { withStyles } from "@material-ui/core/styles";
import {Grid,AppBar,Drawer} from '@material-ui/core';

import styled from 'styled-components';
import _ from 'lodash';
import numeral from 'numeral';
import numberFormatter from 'utils/numberFormatter';

import { getHedge, updateHedgeDetails, hedgeUpdateHedgeEscrow } from "store/state/hedge";
import {getDealName} from 'store/state/deal';
import {getFundName} from 'store/state/fund';
import roundings, {roundingList} from 'constants/roundings';

import {transformNumber, transformRate, transformDscr,transformInteger,transformDecimal, transformBasisPoints} from 'utils/formTransformers'

import hedgeTypes from 'constants/hedgeTypes';
import hedgeStatus from 'constants/hedgeStatus';

import floatingIndexes, {floatingIndexList} from 'constants/floatingIndexes';
import maturityTypes from 'constants/maturityTypes';

import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
import HedgeDetailsToolbar from './HedgeDetailsToolbar';
import EscrowCapModal from "./EscrowCapModal";
import {
ViewOnlyDiv, SectionTitle, ChildSectionTitle, LateralField,
SideLabelCheckboxSelectListInput, SideLabelRadioButtonGroup, 
SideLabelTextInput, SideLabelAutoCompleteInput, SideLabelMoneyInput,
SideLabelDecimalInput, SideLabelCalculatedField, SideLabelDateInput,
SideLabelIntegerInput, SideLabelPercentInput, SideLabelTextAreaInput, 
SideLabelTextAreaWithRefInput, SideLabelTextWithRefInput, SideLabelPercentWithRefInput, 
SideLabelIntegerWithRefInput, SideLabelMoneyWithRefInput} from './FormSectionComponents'

import { ACCESS_TYPE_PORTFOLIO_DEAL } from "constants/accessTypes";
import { getGuestsByDealId } from 'store/state/guest';
import guestPermissionHelper from "utils/guestPermissionHelper"
import dealById from "selectors/deal";
import { fetchDeal } from "store/state/deal";
import { AddButton, SecondaryButton } from 'components/Global/Buttons';


const deal = {value: "Deal", name: "Deal"};
const loan = {value: "Loan", name: "Loan"};
const dealLoan = [deal, loan];

const yesNoList = [
    {id: 1, value: true, name: "Yes"},
    {id: 0, value: false, name: "No"}
];

const downgradeNotificationList = [
    {id: 1, value: true, name: "Notify"},
    {id: 0, value: false, name: "Do Not Notify"}
];

const styles = theme => ({ });

const FormBody = styled(Grid)`
  &&& {
      padding:15px;
      width:810px;
  }
`
const SpacerDiv = styled.div`
  height: 350px;
`;

const FormWrapper = styled.div`
  position:relative;
  overflow:auto;
  max-height:calc(100vh - 216px);
  margin-left:16px;   
`

const RedLiborText = styled.div`
    color: red;
`

class HedgeDetailPage extends React.Component {
    state ={
        redirectTo: null,
        dealId: 'free',
        fundId: 'free',
        loanId: 'free',
        hedgeId: 'free',
        isEditing:false,
        isCancelModalOpen:false,
        isEscrowCapModalOpen:false,
        breadcrumbFund: { id: 'free', name: null},
        breadcrumbDeal: { id: 'free', name: null},     
        breadcrumbHedge: { id: 'free', name: null},       
        initialValues: {
            // Required
            fundId: null, dealId: null, loanId: null, hedgeStatusId: null, hedgeTypeId: null, hedgeProviderId: null, taggedToDeal: deal.value,
            isLenderRequired: false,
            // Optional
            markToMarket: null, terminationValue: null, marketCost: null, marketRate: null, 
            notional: null, strike: null, rate: null, upperStrike: null, lowerStrike: null, cap: null, floor: null, index: null, tradeDate: null, 
            effectiveDate: null, terminationDate: null, earlyTerminationDate: null, premium: null, spread: null, creditCharge: null, 
            ratings: null, collateralAssignment: false, legalOpinion: false, collateralId: null, guaranty: false, paymentDay: null, paymentDayAdjustId: null, 
            calculationDay: null, calculationDayAdjustId: null, roundingId:null, resetDay: null, resetDayAdjustId: null, resetDayLookback: null, lei: null, term: null, 
            ratingsTriggerId: null, spShortDowngradeId: null, spLongDowngradeId: null, moodysShortDowngradeId: null, moodysLongDowngradeId: null, 
            fitchShortDowngradeId: null, fitchLongDowngradeId: null, escrowRequired: false, escrowPeriods: null, monthlyEcrow: null, 
            maturityTypeId: '0b11849b-9bed-11e9-8b5f-00ff12c3b408', daycountId: null, downgradeNotification: true
    },
    guestPermissions: {isGuest: false},
  }

  constructor(props){
   super(props);
   this.formik = React.createRef();
  }

  matchParamsAndSetState(param, altValue){
    const {match} = this.props;
    const id = match.params[param] || altValue;
    this.setState({ [param]: id });
    return id;
  }

   componentDidMount() {
     const hedgeId = this.matchParamsAndSetState("hedgeId", "new");
     const dealId = this.matchParamsAndSetState("dealId");
     const fundId = this.matchParamsAndSetState("fundId");
     
     this.props.getFundName({fundId: fundId, subKey: fundId});
     this.props.getDealName({dealId: dealId, subKey: dealId});
     
     this.props.getHedge({ 
         hedgeId: hedgeId,           
         dealId: dealId});
     this.props.fetchDeal(dealId); 
     this.props.getGuestsByDealId({ dealId: dealId, accessTypeId: ACCESS_TYPE_PORTFOLIO_DEAL  })
    }
      
    componentDidUpdate(prevProps) {
        const {hedgeDetail} = this.props;
        const {hedgeDetail: prevedgeDetails} = prevProps;
        
        if(hedgeDetail !== prevedgeDetails && hedgeDetail.details) {
            let newInitialValues = _.cloneDeep(hedgeDetail.details);
            newInitialValues.taggedToDeal = hedgeDetail.details.loanId ? loan.value : deal.value;            
            this.setState({initialValues: newInitialValues});
        } else if (hedgeDetail !== prevedgeDetails && !hedgeDetail.details){
            this.setState({isEditing: true});
        }
        if(prevProps.hedgeDetail.details===null && this.props.hedgeDetail.details!==null){
            this.props.history.push(`/hedge/free/${this.state.dealId}/${this.props.hedgeDetail.details.id}`);
        }

        const shouldBuildGuestPermissions = guestPermissionHelper.shouldBuildGuestPermissions(this.props.authentication.guestAccess,
            this.props.deal,
            this.props.guestPermission,
            this.props.dealguests);
            if(shouldBuildGuestPermissions && !this.state.guestPermissions.isGuest){
              const guestPermissions = guestPermissionHelper.buildGuestPermissions(this.props.authentication.guestAccess,
                this.props.deal,
                this.props.guestPermission,
                this.props.dealguests,
                "portfolioPermission",
                this.props.history);
                this.setState({guestPermissions: guestPermissions});
              }
    }
    
    assignBreadcrumbNames = (breadcrumbFund, breadcrumbDeal,breadcrumbHedge) => {
        const {hedgeId, dealId, fundId} = this.state;
        const {dealNames, fundNames, hedgeDetail} = this.props;

        breadcrumbFund.id = fundId;
        breadcrumbFund.name = _.get(fundNames[fundId],'name');

        breadcrumbDeal.id = dealId;
        breadcrumbDeal.name = _.get(dealNames[dealId],'name');
        
        breadcrumbHedge.id = hedgeId;
        breadcrumbHedge.name = _.get(hedgeDetail.details, 'hedgeProvider.name') || "New";
    }


    modifyValuesForSerialization = (details) => {
      details.dealId = this.state.dealId;
      details.markToMarket = null;
      details.marketCost = null;
      details.marketRate = null;
      details.strike = transformRate(details.strike);
      details.rate = transformRate(details.rate);
      details.upperStrike = transformRate(details.upperStrike);
      details.lowerStrike = transformRate(details.lowerStrike);
      details.cap = transformRate(details.cap);
      details.floor = transformRate(details.floor);
      details.spread = transformRate(details.spread);
      details.creditCharge = transformBasisPoints(details.creditCharge);
      details.isLenderRequired = details.isLenderRequired;
      if(details.taggedToDeal === deal.value)
          details.loanId = null;
      delete details.deal;
      delete details.fund;
      return details;
    }


    refreshState(){
        //Removed the setTimout.
        //Need a better way to refresh the metrics once the metric service has completed.
    }

    save = () => this.setState(
                               { callbackToCall: () => {this.setState({isEditing:false}); this.refreshState()} },
                               () => this.formik.current.handleSubmit()
                              )

    saveAndReturn = () => this.setState(
                                        { callbackToCall: () => this.setState({redirectTo: `/portfolio/funds/${this.state.fundId}/deals/${this.state.dealId}`}) },
                                        () => this.formik.current.handleSubmit()
                                       )

    openEditMode = () => this.setState({isEditing:true})
    openCancelModal = () => this.setState({isCancelModalOpen: true})    
    closeCancelModal = () => this.setState({isCancelModalOpen: false})
    cancel = () => this.setState({isEditing:false})

    goToEscrowLedger = () => {
        const url = `/hedge/free/${this.state.dealId}/${this.props.hedgeDetail.details.id}/escrowLedger/${this.state.hedgeId}`;
        return this.props.history.push(url);
    }
    toggleEscrowCalculationModel = (isOpen = false, values = null) => {
        this.setState({
            isEscrowCapModalOpen: isOpen
            , callbackToCall: () => this.goToEscrowLedger()
        });

        if(!isOpen && !!values) {
            const formikState = this.formik.current.state.values;
            const clonedValues = _.cloneDeep(formikState);
            const serializedHedge = this.modifyValuesForSerialization(clonedValues);
            const hedge = {
                ...serializedHedge
                , ...values
                , term: values.escrowTerm
            };

            let hedgeDetailsRequest = {
                isNew: true
                , hedge
                , callback: () => this.goToEscrowLedger()
            };

            this.props.hedgeUpdateHedgeEscrow(hedgeDetailsRequest);   
        }
    }
        
    shouldShow(values, field){
        const type = values.hedgeTypeId;
        const status = values.hedgeStatusId;
        let activeFields = [];
        activeFields = []

        switch (type) {
            case hedgeTypes.CAP: 
            case hedgeTypes.FLOOR:        
                switch (status) {
                    case hedgeStatus.ACTIVE:
                        activeFields = ['daycountId','calculationDay','calculationDayAdjustId','roundingId','collateralAssignment','effectiveDate','fitchLongDowngradeId', 'downgradeNotification','fitchShortDowngradeId','hedgeProviderId','hedgeStatusId','hedgeTypeId','indexId','isLenderRequired','legalOpinion','lei','markToMarket','moodysLongDowngradeId',
                                        'moodysShortDowngradeId','notional','paymentDay','paymentDayAdjustId','premium','ratings','resetDay','resetDayAdjustId','resetDayLookback','spLongDowngradeId','spShortDowngradeId','strike','taggedToDeal','terminationDate','tradeDate',];
                        break;
                    case hedgeStatus.TERMINATED:
                        activeFields = ['daycountId','calculationDay','calculationDayAdjustId','roundingId','collateralAssignment','earlyTerminationDate','effectiveDate','fitchLongDowngradeId', 'downgradeNotification','fitchShortDowngradeId','hedgeProviderId','hedgeStatusId','hedgeTypeId','indexId','isLenderRequired','legalOpinion','lei','moodysLongDowngradeId',
                                        'moodysShortDowngradeId', 'notionalAtTermination','paymentDay','paymentDayAdjustId','premium','ratings','resetDay','resetDayAdjustId','resetDayLookback','spLongDowngradeId','spShortDowngradeId','strike','taggedToDeal','terminationDate','terminationValue','tradeDate',];
                        break;
                    case hedgeStatus.WATCH:
                        activeFields = ['maturityTypeId','daycountId','effectiveDate','hedgeStatusId','hedgeTypeId','indexId','isLenderRequired','marketCost','notional','ratingsTriggerId','strike','taggedToDeal','term','terminationDate',];
                        break;
                }
                break;
            case hedgeTypes.SWAP:        
                switch (status) {
                    case hedgeStatus.ACTIVE:
                        activeFields = ['daycountId','calculationDay','calculationDayAdjustId','roundingId','collateralId','creditCharge','effectiveDate','fitchLongDowngradeId', 'downgradeNotification','fitchShortDowngradeId','guaranty','hedgeProviderId','hedgeStatusId',
                                        'hedgeTypeId','indexId','isLenderRequired','lei','moodysLongDowngradeId','moodysShortDowngradeId','notional','paymentDay','paymentDayAdjustId','rate','ratings','resetDay','resetDayAdjustId',
                                        'resetDayLookback','spLongDowngradeId','spread','spShortDowngradeId','taggedToDeal','terminationDate','tradeDate','markToMarket',];
                        break;
                    case hedgeStatus.TERMINATED:
                        activeFields = ['notionalAtTermination','daycountId','calculationDay','calculationDayAdjustId','roundingId','collateralId','creditCharge','earlyTerminationDate','effectiveDate','fitchLongDowngradeId', 'downgradeNotification','fitchShortDowngradeId','guaranty','hedgeProviderId',
                                        'hedgeStatusId','hedgeTypeId','indexId','isLenderRequired','lei','moodysLongDowngradeId','moodysShortDowngradeId','paymentDay','paymentDayAdjustId','rate','ratings','resetDay','resetDayAdjustId',
                                        'resetDayLookback','spLongDowngradeId','spread','spShortDowngradeId','taggedToDeal','terminationDate','terminationValue','tradeDate',];
                        break;
                    case hedgeStatus.WATCH:
                        activeFields = ['maturityTypeId','daycountId','creditCharge','effectiveDate','hedgeStatusId','hedgeTypeId','indexId','isLenderRequired','marketRate','notional','spread','taggedToDeal','term','terminationDate',];
                        break;
                }
                break;
            case hedgeTypes.CORRIDOR:        
                switch (status) {
                    case hedgeStatus.ACTIVE:
                        activeFields = ['daycountId','calculationDay','calculationDayAdjustId','roundingId','effectiveDate','fitchLongDowngradeId', 'downgradeNotification','fitchShortDowngradeId','hedgeProviderId','hedgeStatusId','hedgeTypeId','indexId','isLenderRequired','lei','lowerStrike',
                                        'moodysLongDowngradeId','moodysShortDowngradeId','notional','paymentDay','paymentDayAdjustId','premium','ratings','resetDay','resetDayAdjustId','resetDayLookback','spLongDowngradeId','spShortDowngradeId',
                                        'taggedToDeal','terminationDate','tradeDate','upperStrike',];
                        break;
                    case hedgeStatus.TERMINATED:
                        activeFields = ['notionalAtTermination','daycountId','calculationDay','calculationDayAdjustId','roundingId','earlyTerminationDate','effectiveDate','fitchLongDowngradeId', 'downgradeNotification','fitchShortDowngradeId','hedgeProviderId','hedgeStatusId','hedgeTypeId','indexId','isLenderRequired','lei','lowerStrike',
                                        'moodysLongDowngradeId','moodysShortDowngradeId','paymentDay','paymentDayAdjustId','premium','ratings','resetDay','resetDayAdjustId','resetDayLookback','spLongDowngradeId','spShortDowngradeId',
                                        'taggedToDeal','terminationDate','terminationValue','tradeDate','upperStrike',];
                        break;
                    case hedgeStatus.WATCH:
                        activeFields = [];
                        break;
                }
                break;
            case hedgeTypes.COLLAR:        
                switch (status) {
                    case hedgeStatus.ACTIVE:
                        activeFields = ['daycountId','calculationDay','calculationDayAdjustId','roundingId','cap','collateralId','effectiveDate','fitchLongDowngradeId', 'downgradeNotification','fitchShortDowngradeId','floor','guaranty','hedgeProviderId','hedgeStatusId','hedgeTypeId','indexId','isLenderRequired','lei',
                                        'moodysLongDowngradeId','moodysShortDowngradeId','notional','paymentDay','paymentDayAdjustId','premium','ratings','resetDay','resetDayAdjustId','resetDayLookback','spLongDowngradeId','spShortDowngradeId',
                                        'taggedToDeal','terminationDate','tradeDate',];
                        break;
                    case hedgeStatus.TERMINATED:
                        activeFields = ['notionalAtTermination', 'daycountId','calculationDay','calculationDayAdjustId','roundingId','cap','collateralId','earlyTerminationDate','effectiveDate','fitchLongDowngradeId', 'downgradeNotification','fitchShortDowngradeId','floor','guaranty','hedgeProviderId','hedgeStatusId','hedgeTypeId',
                                        'indexId','isLenderRequired','lei','moodysLongDowngradeId','moodysShortDowngradeId','paymentDay','paymentDayAdjustId','premium','ratings','resetDay','resetDayAdjustId','resetDayLookback','spLongDowngradeId','spShortDowngradeId',
                                        'taggedToDeal','terminationDate','terminationValue','tradeDate',];
                        break;
                    case hedgeStatus.WATCH:
                        activeFields = [];
                        break;
                }
                break;
        }
        return _.includes(activeFields, field);
    }

    sortHedgeTypes (ancillary) {
        if (!ancillary) return [];
        const hedgeTypes = ancillary.hedgeType;
        const temp = [...hedgeTypes];
        const floorVal = temp[0];
        temp.shift();
        temp.push(floorVal);
        return temp;
    }

    calculateMarkToMarketDisplayValue(markToMarketValue) {
        if (!markToMarketValue) 
            return "--";
        else 
            return numberFormatter.maskCurrency(markToMarketValue);
    }

    statusAndMaturityCheck(values, maturity) {
        return ((values.hedgeStatusId === hedgeStatus.ACTIVE || values.hedgeStatusId === hedgeStatus.TERMINATED) || (values.hedgeStatusId === hedgeStatus.WATCH && values.maturityTypeId === maturity))
    }

    render() {
        this.assignBreadcrumbNames(this.state.breadcrumbFund,this.state.breadcrumbDeal,this.state.breadcrumbHedge);

        const { hedgeId, isEditing,  redirectTo, isCancelModalOpen, initialValues, guestPermissions, } = this.state;
        const {classes, ancillary, authentication} = this.props;
        const sortedHedgeTypes = this.sortHedgeTypes(ancillary);
        
        if(!ancillary) return null;

        if(redirectTo) return <Redirect to={redirectTo} />

        return (
            <Fragment>
                <Grid container alignItems="flex-start" justify="flex-start" direction="row">
                    <Grid item xs={12} lg={12}>
                        <HedgeDetailsToolbar
                            fund={this.state.breadcrumbFund}
                            deal={this.state.breadcrumbDeal}                        
                            hedge={this.state.breadcrumbHedge}
                            isEditing={isEditing}
                            onOpenEditMode={this.openEditMode}
                            onCancel={this.openCancelModal}
                            onSave={this.save}
                            onSaveAndReturn={this.saveAndReturn}
                            guestPermissions={guestPermissions}
                            authentication={authentication}
                        />
                    </Grid>
                    
                    <Grid item xs={12} lg={12}>
                      <FormWrapper >
                        <Formik
                                ref={this.formik}                                
                                enableReinitialize
                                validateOnChange={true}
                                initialValues={initialValues}                
                                validate={values => {
                                                        let errors = {};
                                                        if (!values.taggedToDeal) {errors.taggedToDeal = 'Required'}
                                                        if (values.taggedToDeal === loan.value && !values.loanId) {errors.loanId = 'Required'}
                                                        if (!values.hedgeStatusId) {errors.hedgeStatusId = 'Required'}
                                                        if (!values.hedgeTypeId) {errors.hedgeTypeId = 'Required'}
                                                        if (this.shouldShow(values, "hedgeProviderId") && !values.hedgeProviderId) {errors.hedgeProviderId = 'Required'}
                                                        return errors;
                                                    }}
                                onSubmit={(values,{setSubmitting}) => {   
                                    let hedgeDetailsRequest = {}
                                    if(!hedgeId) {
                                      hedgeDetailsRequest.isNew = true;
                                    } else {
                                      hedgeDetailsRequest.id = hedgeId;
                                      hedgeDetailsRequest.isNew = hedgeId === "new";
                                      const clonedValues = _.cloneDeep(values);
                                      hedgeDetailsRequest.hedge = this.modifyValuesForSerialization(clonedValues);
                                      hedgeDetailsRequest.callback = this.state.callbackToCall
                                      this.setState({isEditing: false});
                                      this.props.updateHedgeDetails(hedgeDetailsRequest);   
                                      
                                    }        
                                    setSubmitting(false);
                                  }}                                
                                render={({values,errors,status,touched, isSubmitting,handleChange, handleBlur,handleSubmit, setFieldValue}) => {
                                    return (<FormBody container item xs={12} lg={12}>
                                                <SideLabelAutoCompleteInput id="dropdownForhedgeTypeId" label="Hedge Type*" fieldName="hedgeTypeId" selectValue="value" options={sortedHedgeTypes} isDisabled={!isEditing} />
                                                

                                                {values.hedgeTypeId && values.hedgeTypeId  !== hedgeTypes.COLLAR && values.hedgeTypeId  !== hedgeTypes.CORRIDOR && values.hedgeTypeId  !== hedgeTypes.FLOOR && (
                                                        <SideLabelAutoCompleteInput  id="dropdownForhedgeStatusId" label="Status*" fieldName="hedgeStatusId" selectValue="value" options={ancillary.hedgeStatus} isDisabled={!isEditing}  />
                                                )}  
                                                
                                                {values.hedgeTypeId && (values.hedgeTypeId  === hedgeTypes.COLLAR || values.hedgeTypeId  === hedgeTypes.CORRIDOR || values.hedgeTypeId  === hedgeTypes.FLOOR ) && (
                                                        <SideLabelAutoCompleteInput  label="Status*" fieldName="hedgeStatusId" selectValue="value" options={ancillary.hedgeStatus.filter(x => x.value !== hedgeStatus.WATCH)} isDisabled={!isEditing}  />
                                                )} 
                                                {/* Start Conditional Fields*/}

                                                    {this.shouldShow(values, "markToMarket") && (
                                                        <LateralField label="Mark-To-Market">
                                                            {values.indexId === floatingIndexes.ONE_MONTH_LIBOR ? <ViewOnlyDiv>{this.calculateMarkToMarketDisplayValue(values.markToMarket)}</ViewOnlyDiv> : <RedLiborText>{"Mark-To-Market will only be calculated on 1-Month LIBOR"}</RedLiborText>}
                                                        </LateralField>                                                        
                                                    )}                                                
                                                    {this.shouldShow(values, "terminationValue") && (
                                                        <SideLabelMoneyInput label="Termination Value/(Cost)" fieldName="terminationValue" isDisabled={!isEditing} />
                                                    )}                                                
                                                    {this.shouldShow(values, "marketCost") && (
                                                        <LateralField label="Market Cost"><ViewOnlyDiv>{!values.marketCost ? "--" : numeral(values.marketCost).format('$0,0')}</ViewOnlyDiv></LateralField>
                                                    )}                                                
                                                    {this.shouldShow(values, "marketRate") && (
                                                        <LateralField label="Market Rate"><ViewOnlyDiv>{!values.marketRate ? "--" : numeral(values.marketRate/100).format('0.00%')}</ViewOnlyDiv></LateralField>
                                                    )}                                                
                                                    {this.shouldShow(values, "notional") && (
                                                        <SideLabelMoneyInput label="Notional" fieldName="notional" isDisabled={!isEditing} /> 
                                                    )}       
                                                    {this.shouldShow(values, "notionalAtTermination") && (
                                                        <SideLabelMoneyInput label="Notional At Termination" fieldName="notionalAtTermination" isDisabled={!isEditing} /> 
                                                    )}                                          
                                                    {this.shouldShow(values, "strike") && (
                                                        <SideLabelPercentInput label="Strike" fieldName="strike" isDisabled={!isEditing} decimalScale={3} />
                                                    )}                                                
                                                    {this.shouldShow(values, "rate") && (
                                                        <SideLabelPercentInput label="Rate" fieldName="rate" isDisabled={!isEditing} decimalScale={3}/>
                                                    )}                                                
                                                    {this.shouldShow(values, "upperStrike") && (
                                                        <SideLabelPercentInput label="Upper Strike" fieldName="upperStrike" isDisabled={!isEditing} decimalScale={3} />
                                                    )}                                                
                                                    {this.shouldShow(values, "lowerStrike") && (
                                                        <SideLabelPercentInput label="Lower Strike" fieldName="lowerStrike" isDisabled={!isEditing} decimalScale={3} />                                                
                                                    )}                                                
                                                    {this.shouldShow(values, "cap") && (
                                                        <SideLabelPercentInput label="Cap" fieldName="cap" isDisabled={!isEditing} decimalScale={3} />
                                                    )}                                                
                                                    {this.shouldShow(values, "floor") && (
                                                        <SideLabelPercentInput label="Floor" fieldName="floor" isDisabled={!isEditing} decimalScale={3} />
                                                    )}                                                
                                                    {this.shouldShow(values, "indexId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForindexId" label="Index" fieldName="indexId" selectValue="value" options={ancillary.floatingIndices} isDisabled={!isEditing}  />
                                                    )}
                                                    {this.shouldShow(values, "maturityTypeId") && (
                                                        <SideLabelRadioButtonGroup label="Maturity Type" fieldName="maturityTypeId" isDisabled={!isEditing} setFieldValue={setFieldValue} options={ancillary.maturityTypes} />
                                                    )}                           
                                                    {this.shouldShow(values, "tradeDate") && (
                                                        <SideLabelDateInput label="Trade Date" fieldName="tradeDate" isDisabled={!isEditing} />   
                                                    )}                                                
                                                    {this.shouldShow(values, "effectiveDate") && this.statusAndMaturityCheck(values, maturityTypes.CONSTANT_MATURITY) && (
                                                        <SideLabelDateInput label="Effective Date" fieldName="effectiveDate" isDisabled={!isEditing} />
                                                    )}                                                
                                                    {this.shouldShow(values, "terminationDate") && this.statusAndMaturityCheck(values, maturityTypes.CONSTANT_MATURITY) && (
                                                        <SideLabelDateInput label="Termination Date" fieldName="terminationDate" isDisabled={!isEditing} />
                                                    )}                                                
                                                    {this.shouldShow(values, "earlyTerminationDate") && (
                                                        <SideLabelDateInput label="Early Termination Date" fieldName="earlyTerminationDate" isDisabled={!isEditing} />  
                                                    )}                                                
                                                    {this.shouldShow(values, "premium") && (
                                                        <SideLabelMoneyInput label="Premium" fieldName="premium" isDisabled={!isEditing} />
                                                    )}                                                
                                                    {this.shouldShow(values, "spread") && (
                                                        <SideLabelPercentInput label="Spread" fieldName="spread" isDisabled={!isEditing} />
                                                    )}                                                
                                                    {this.shouldShow(values, "creditCharge") && (
                                                        <SideLabelDecimalInput label="Credit Charge (bps)" fieldName="creditCharge" decimalScale={3} isDisabled={!isEditing} />
                                                    )}                                                
                                                    {this.shouldShow(values, "hedgeProviderId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForhedgeProviderId" label="Hedge Provider*" fieldName="hedgeProviderId" selectValue="value" options={ancillary.hedgeProviders} isDisabled={!isEditing}  />      
                                                    )}                                                
                                                    {this.shouldShow(values, "ratings") && (
                                                        <SideLabelTextAreaInput id="dropdownForratingsTriggerId" label="Ratings" fieldName="ratings" isDisabled={!isEditing} /> 
                                                    )}
                                                    {this.shouldShow(values, "collateralAssignment") && ( 
                                                        <SideLabelRadioButtonGroup name="collateralAssignment" label="Collateral Assignment" fieldName="collateralAssignment" isDisabled={!isEditing} setFieldValue={setFieldValue} options={yesNoList} />                                                        
                                                    )}                                               
                                                    {this.shouldShow(values, "legalOpinion") && (
                                                        <SideLabelRadioButtonGroup name="legalOpinion" label="Legal Opinion" fieldName="legalOpinion" isDisabled={!isEditing} setFieldValue={setFieldValue} options={yesNoList} />                                                       
                                                    )}
                                                    {this.shouldShow(values, "collateralId") && (
                                                        <SideLabelAutoCompleteInput label="Collateral" fieldName="collateralId" selectValue="value" options={ancillary.collaterals} isDisabled={!isEditing} />
                                                    )}                                                
                                                    {this.shouldShow(values, "guaranty") && (
                                                        <SideLabelRadioButtonGroup label="Guaranty" fieldName="guaranty" isDisabled={!isEditing} setFieldValue={setFieldValue} options={yesNoList} />                                                        
                                                    )}                                                
                                                    {this.shouldShow(values, "paymentDay") && (
                                                        <>
                                                            <SideLabelIntegerInput label="Payment Dates" fieldName="paymentDay" isDisabled={!isEditing} tooltip={values.paymentDayTooltip} />
                                                            {isEditing && <SideLabelTextAreaInput id="paymentDayTooltip" label="Payment Dates Tooltip" fieldName="paymentDayTooltip" isDisabled={!isEditing} /> }
                                                        </>
                                                    )}                                                
                                                    {this.shouldShow(values, "paymentDayAdjustId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForpaymentDayAdjustId" label="Payment Adjustment" fieldName="paymentDayAdjustId" selectValue="value" options={ancillary.paymentDayAdjustments} isDisabled={!isEditing}  />
                                                    )}                                                
                                                    {this.shouldShow(values, "calculationDay") && (
                                                        <>
                                                        <SideLabelIntegerInput label="Calculation Dates" fieldName="calculationDay" isDisabled={!isEditing} tooltip={values.calculationDayTooltip}/>
                                                       {isEditing && <SideLabelTextAreaInput id="calculationDayTooltip" label="Calculation Dates Tooltip" fieldName="calculationDayTooltip" isDisabled={!isEditing} /> }
                                                        </>
                                                    )}                                                
                                                    {this.shouldShow(values, "calculationDayAdjustId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForcalculationDayAdjustId" label="Calculation Adjustment" fieldName="calculationDayAdjustId" selectValue="value" options={ancillary.calculationDayAdjustments} isDisabled={!isEditing}  />    
                                                    )}
                                                    {this.shouldShow(values, "roundingId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForroundingId" label="Calculation Rounding" fieldName="roundingId" selectValue="value" options={roundingList} isDisabled={!isEditing}  />    
                                                    )}                    
                                                    {this.shouldShow(values, "resetDay") && (
                                                        <>
                                                        <SideLabelIntegerInput label="Reset Dates" fieldName="resetDay" isDisabled={!isEditing} tooltip={values.resetDayTooltip}/>
                                                        {isEditing && <SideLabelTextAreaInput id="resetDayTooltip" label="Reset Dates Tooltip" fieldName="resetDayTooltip" isDisabled={!isEditing} /> }
                                                        </>
                                                    )}                                                
                                                    {this.shouldShow(values, "resetDayAdjustId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForresetDayAdjustId" label="Reset Adjustment" fieldName="resetDayAdjustId" selectValue="value" options={ancillary.resetDayAdjustments} isDisabled={!isEditing}  />
                                                    )}                                                
                                                    {this.shouldShow(values, "resetDayLookback") && (
                                                        <SideLabelIntegerInput label="Lookback Days" fieldName="resetDayLookback" isDisabled={!isEditing} />   
                                                    )}
                                                    {this.shouldShow(values, "daycountId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownFordaycountId" label="Daycount Ratio" fieldName="daycountId" selectValue="value" options={ancillary.dayCounts} isDisabled={!isEditing}  />
                                                    )}                                      
                                                    {this.shouldShow(values, "lei") && (
                                                        <SideLabelTextInput label="LEI" fieldName="lei" isDisabled={!isEditing} />
                                                    )}                                                
                                                    {this.shouldShow(values, "term") && this.statusAndMaturityCheck(values, maturityTypes.ROLLING_MATURITY) && (
                                                        <SideLabelIntegerInput label="Term (months)" fieldName="term" isDisabled={!isEditing} />                                                
                                                    )}                                                
                                                    {this.shouldShow(values, "ratingsTriggerId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForratingsTriggerId" label="Ratings" fieldName="ratingsTriggerId" selectValue="value" options={ancillary.ratingsTriggers} isDisabled={!isEditing}  />
                                                    )}                                                
                                                    {this.shouldShow(values, "taggedToDeal") && (
                                                        <SideLabelRadioButtonGroup label="Tagged To" fieldName="taggedToDeal" isDisabled={!isEditing} setFieldValue={setFieldValue} options={dealLoan} />
                                                    )}
                                                    {(values.hedgeStatusId && values.taggedToDeal === loan.value) && (
                                                        <SideLabelAutoCompleteInput label="Loan*" fieldName="loanId" selectValue="value" options={ancillary.hedgeLoans} isDisabled={!isEditing} />
                                                    )}
                                                    {this.shouldShow(values, 'isLenderRequired') && (
                                                        <SideLabelRadioButtonGroup label="Required Hedge" fieldName="isLenderRequired" isDisabled={!isEditing} setFieldValue={setFieldValue} options={yesNoList} />
                                                    )}
                                                    {this.shouldShow(values, "spShortDowngradeId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForspShortDowngradeId" label="S&P Short" fieldName="spShortDowngradeId" selectValue="value" options={ancillary.spShortDowngrades} isDisabled={!isEditing}  /> 
                                                    )}                                                
                                                    {this.shouldShow(values, "spLongDowngradeId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForspLongDowngradeId" label="S&P Long" fieldName="spLongDowngradeId" selectValue="value" options={ancillary.spLongDowngrades} isDisabled={!isEditing}  /> 
                                                    )}                                                
                                                    {this.shouldShow(values, "moodysShortDowngradeId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownFormoodysShortDowngradeId" label="Moody's Short" fieldName="moodysShortDowngradeId" selectValue="value" options={ancillary.moodysShortDowngrades} isDisabled={!isEditing}  />      
                                                    )}                                                
                                                    {this.shouldShow(values, "moodysLongDowngradeId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownFormoodysLongDowngradeId" label="Moody's Long" fieldName="moodysLongDowngradeId" selectValue="value" options={ancillary.moodysLongDowngrades} isDisabled={!isEditing}  />  
                                                    )}                                                
                                                    {this.shouldShow(values, "fitchShortDowngradeId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForfitchShortDowngradeId" label="Fitch Short" fieldName="fitchShortDowngradeId" selectValue="value" options={ancillary.fitchShortDowngrades} isDisabled={!isEditing}  />  
                                                    )}                                                
                                                    {this.shouldShow(values, "fitchLongDowngradeId") && (
                                                        <SideLabelAutoCompleteInput id="dropdownForfitchLongDowngradeId" label="Fitch Long" fieldName="fitchLongDowngradeId" selectValue="value" options={ancillary.fitchLongDowngrades} isDisabled={!isEditing}  />  
                                                    )}                                            
                                                    {this.shouldShow(values, "downgradeNotification") && (
                                                        <SideLabelRadioButtonGroup label="Downgrade Notfication" fieldName="downgradeNotification" isDisabled={!isEditing} setFieldValue={setFieldValue} options={downgradeNotificationList} />
                                                    )}
                                                    {
                                                    isEditing && values.hedgeStatusId === hedgeStatus.ACTIVE && values.hedgeTypeId === hedgeTypes.CAP && (!values || !values.hedgeEscrows || !values.hedgeEscrows.length ? 
                                                        <AddButton id="addEscrowCalculation" onClick={() => this.toggleEscrowCalculationModel(true)} title="Add Escrow Calculation"/>
                                                        : <SecondaryButton id="goToEscrowCalculation" onClick={this.goToEscrowLedger}>GO TO ESCROW CALCULATION</SecondaryButton>)
                                                    }

                                            </FormBody>)}
                                        }/>                                             
                        <SpacerDiv></SpacerDiv>                
                        </FormWrapper>                        
                    </Grid>               
                </Grid>

                <EscrowCapModal
                    isOpen={this.state.isEscrowCapModalOpen}
                    handleClose = {this.toggleEscrowCalculationModel}
                    saveButtonText='CREATE ESCROW CAP'
                />

                <SimpleConfirmDialog 
                    title="Confirm Cancel"
                    message="You are about to cancel all of your changes. Are you sure you want to do this?"
                    noText="NO"
                    yesText="YES, CANCEL"
                    modalOpen={isCancelModalOpen}
                    handleNo={this.closeCancelModal}
                    handleYes={() => {
                        this.formik.current.handleReset();
                        if(this.state.hedgeId === "new"){
                            this.setState({isCancelModalOpen:false, isEditing:false, redirectTo: `/portfolio/funds/${this.state.fundId}/deals/${this.state.dealId}`})
                        } else {
                            this.setState({isCancelModalOpen:false, isEditing:false})
                    }                        
                        
                    }} />
          </Fragment>

            
          );
}
}
const mapStateToProps = (state, { match: { params: { dealId } } }) => {
    const {authentication, deal, fund, hedge, guest} = state;
    return ({
        authentication,
        deal: dealById(state, dealId),
        dealStore: deal,
        dealNames: deal.dealNames,
        fundNames: fund.fundNames,
        hedgeDetail: hedge.hedgeDetail,
        ancillary: hedge.hedgeDetail ? hedge.hedgeDetail.ancillary : null,
        dealguests: guest.dealguests ? guest.dealguests[dealId] : [],
        guestPermission: guest.guestPermission ? guest.guestPermission : null,
    })
 }

export default compose(
    withRouter,
    connect(mapStateToProps, {
        getHedge,
        getDealName,
        getFundName,
        updateHedgeDetails,
        getFundName,
        fetchDeal,
        getGuestsByDealId,
        hedgeUpdateHedgeEscrow
    }),
    withStyles(styles))(HedgeDetailPage);
    